import * as React from 'react'
import { t } from 'ttag'
import { currentLang, isRtl } from '../../i18nInit'
import YumButton from '../YumButton/YumButton'
import { ReactComponent as AppleIcon } from '../../assets/v2/icons/icon-apple.svg'
import { isNative } from '../../common/helpers/isNative'
import { openUrl } from '../../common/helpers/routeHelpers'
import { formatIntegrationUrl } from '../../common/helpers/integrationUrl'
import { apiDomain } from '../../services/apiUrl'
import './YumAppleSignIn.scss'
import { Preferences } from '@capacitor/preferences'
import { Dialog } from '@capacitor/dialog'

const APPLE_SIGN_IN_CLIENT_ID = 'com.yumuuv.web'

export interface IStateProps {
  buttonText?: string
  isSignUp: boolean
  disabled?: boolean
}

export interface IDispatchProps {
  getWhoAmI(): void
  doAppleSignIn(): void
  doAppleSignInFail(msg: string): void
}

type YumAppleSignInProps = IStateProps & IDispatchProps

const randomString = (length: number) => {
  const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._'
  let result = ''

  while (length > 0) {
    const bytes = new Uint8Array(16)
    const random = window.crypto.getRandomValues(bytes)

    // eslint-disable-next-line
    random.forEach(function (c) {
      if (length === 0) {
        return
      }
      if (c < charset.length) {
        result += charset[c]
        length--
      }
    })
  }
  return result
}

export const getAppleSignInRedirectUri = () => {
  return `${apiDomain}/api/auth/signInWithApple`
  /*let redirectUri = `${apiDomain}/api/auth/signInWithApple`
  if (isNative()) {
    // For Cordova apps, we're adding a proxy to know later if and where to redirect.
    const proxy = isNative() ? '/apple-proxy' : ''
    const globalState = (store.getState() as any) as IGlobalState
    if (globalState.router && globalState.router.location && globalState.router.location.pathname) {
      redirectUri = `${appDomain}${proxy}${globalState.router.location.pathname}`
    } else {
      redirectUri = `${appDomain}${proxy}${ROUTES.SIGNUP.to}`
    }
  }
  return redirectUri*/
}

const getAppleIntegrationUrl = async (isSignUp: boolean, companyCode: string | null) => {
  const baseUrl = 'https://appleid.apple.com/auth/authorize'

  const redirectUri = getAppleSignInRedirectUri()
  const nonce = randomString(16)

  const { value: sessionId } = await Preferences.get({ key: 'sessionId' })

  const state = JSON.stringify({
    lang: currentLang,
    companyCode,
    redirectUri,
    nonce,
    isSignUp: isSignUp ? 'true' : 'false',
    isCordova: isNative() ? 'true' : 'false',
    isWeb: !isNative() ? 'true' : 'false',
    sessionId: sessionId,
  })

  const parameters = [
    'response_type=code%20id_token',
    `nonce=${nonce}`,
    `state=${encodeURIComponent(state)}`,
    'scope=name%20email',
    `client_id=${APPLE_SIGN_IN_CLIENT_ID}`,
    `redirect_uri=${encodeURIComponent(redirectUri)}`,
    `response_mode=form_post`,
  ]

  return formatIntegrationUrl(baseUrl, parameters)
}

const signUpWithApple = (isSignUp: boolean) => async () => {
  let companyCode: string | null = null
  if (isSignUp) {
    const { value: consent } = await Dialog.confirm({
      title: '',
      message: t`Do you agree to YuMuuv's Terms of Service and Privacy Policy?`,
      okButtonTitle: t`Yes, I agree!`,
      cancelButtonTitle: t`No`,
    })
    if (!consent) return

    const { value, cancelled } = await Dialog.prompt({
      title: '',
      message: t`Sign-up code`,
    })
    companyCode = value
    if (!companyCode || cancelled) return
  }
  const url = await getAppleIntegrationUrl(isSignUp, companyCode)
  await openUrl(url)
}

export class YumAppleSignIn extends React.PureComponent<YumAppleSignInProps> {
  async componentDidMount(): Promise<void> {
    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search)
      const msg = searchParams.get('signInWithApple') || ''

      if (msg && msg !== '') {
        if (msg === 'success') {
          this.props.doAppleSignIn()
        } else {
          this.props.doAppleSignInFail(msg)
        }
      }
    }
  }

  render() {
    return (
      <>
        <YumButton
          className={'btn-sign-in-with-apple'}
          onClick={signUpWithApple(this.props.isSignUp)}
          variant="outlined"
          disabled={this.props.disabled}
          style={{
            width: '100%',
            whiteSpace: 'nowrap',
            fontWeight: 400,
            /*paddingLeft: 18,
            paddingRight: 18,
            marginLeft: 0,
            marginRight: 0,
            lineHeight: '34px',*/
            marginBottom: '16px',
            fontSize: '14px',
            backgroundColor: '#000',
            color: '#fff',
            borderColor: '#000',
            //display: 'inline-block',
            //textTransform: 'unset',
          }}
        >
          <AppleIcon style={{ marginTop: -4, marginRight: isRtl ? 0 : 10, marginLeft: isRtl ? 10 : 0 }} />
          {this.props.buttonText || t`Sign up with Apple`}
        </YumButton>
      </>
    )
  }
}
